var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"error-btn-back"},on:{"click":function($event){return _vm.$router.push('/')}}},[_c('CbrIcon',{attrs:{"size":"15"}},[_vm._v("$triangle_right")]),_vm._v(" "+_vm._s(_vm.$t('event_creation_editing_popup_error_edit_lbl_back_list_events'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }